export default "__VITE_ASSET__61b073f5__"